"use client"

import { useState } from "react"
import "./Login.css"
const image1 = "https://ik.imagekit.io/b4rykldk3/artes_Mesa%20de%20trabajo%201.1.webp?updatedAt=1777044887228";
const image2 = "https://ik.imagekit.io/b4rykldk3/logo_animado.gif?updatedAt=1777044897392";
import API_URL from "../../config/api" // ✅ importar

function LoginModal({ isOpen, onClose }) {
  const [usuario, setUsuario] = useState("")
  const [contraseña, setContraseña] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [autenticado, setAutenticado] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    if (!usuario || !contraseña) {
      setError("Por favor ingrese usuario y contraseña")
      return
    }

    try {
      setLoading(true)

      const response = await fetch(`${API_URL}/api/auth/login`, { // ✅ corregido
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario, contraseña }),
        credentials: "include",
      })

      let data
      const contentType = response.headers.get("content-type")
      if (contentType && contentType.includes("application/json")) {
        data = await response.json()
      } else {
        const textResponse = await response.text()
        console.error("Respuesta no válida:", textResponse)
        throw new Error("El servidor no devolvió un formato JSON válido")
      }

      if (!response.ok) {
        throw new Error(data.message || "Error al iniciar sesión")
      }

      await new Promise((resolve) => setTimeout(resolve, 1800))

      setAutenticado(true)
      localStorage.setItem("usuario", JSON.stringify(data.usuario))
      localStorage.setItem("canvaUserLoggedIn", "true")

      setTimeout(() => {
        window.location.href = "/dashboard"
      }, 2000)
    } catch (err) {
      console.error("Error de login:", err)
      setError(err.message || "Error al iniciar sesión")
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <button className="modal-close-btn" onClick={onClose}>&times;</button>

        <div className="modal-content">
          {autenticado ? (
            <div className="login-success">
              <div className="success-icon">✓</div>
              <h2>¡Inicio de sesión exitoso!</h2>
              <p>Bienvenido al sistema, {usuario}.</p>
              <p className="redirect-message">Redirigiendo al dashboard...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-logo">
                <img src={image1 || "/placeholder.svg"} alt="Logo" className="logo-image" />
              </div>

              <h2>Iniciar Sesión</h2>
              <p>Ingrese sus credenciales para acceder al sistema</p>

              {error && <div className="error-message">{error}</div>}

              <div className="form-group">
                <label htmlFor="usuario">Usuario</label>
                <input
                  id="usuario"
                  type="text"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  placeholder="Ingrese su usuario"
                />
              </div>

              <div className="form-group">
                <label htmlFor="contraseña">Contraseña</label>
                <input
                  id="contraseña"
                  type="password"
                  value={contraseña}
                  onChange={(e) => setContraseña(e.target.value)}
                  placeholder="Ingrese su contraseña"
                />
              </div>

              <div className="form-actions">
               
                <button type="submit" className="login-btn" disabled={loading}>
                  {loading ? "Procesando..." : "Iniciar Sesión"}
                </button>
                 <button type="button" className="cancel-btn" onClick={onClose}>Cancelar</button>
              </div>
            </form>
          )}
        </div>

        {loading && (
          <div className="loading-overlay">
            <img src={image2 || "/placeholder.svg"} alt="Cargando..." className="loading-gif" />
          </div>
        )}
      </div>
    </div>
  )
}

export default LoginModal